import { render, staticRenderFns } from "./AddNewCategory.vue?vue&type=template&id=3e1fe6e2&"
import script from "./AddNewCategory.vue?vue&type=script&lang=js&"
export * from "./AddNewCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports